module.exports = __webpack_public_path__ + "img/jixiao.11bd48ed.svg";